import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/modules/shared/components/base.component';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { Permission } from 'src/app/modules/shared/enums/enums';

@Component({
  selector: 'app-forbidden-page',
  templateUrl: './forbidden-page.component.html',
  styleUrls: ['./forbidden-page.component.scss']
})
export class ForbiddenPageComponent extends BaseComponent {
  header: string;
  message: string;

  constructor(private translate: TranslateService, private route: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      let permissionParam = params['permission'];
      if (permissionParam) {
        let permissionAsKey = permissionParam.toUpperCase() as keyof typeof Permission;
        if (permissionAsKey) {
          let permission = Permission[permissionAsKey];
          if (permission) {
            this.header = this.translate.instant('forbiddenHeader_' + permission.toString());    
            this.message = this.translate.instant('forbiddenMessage_' + permission.toString());    
          }
        }
      }
    });
  }

}
